export function formatPhone(input) {
    if (!input || isNaN(input)) return input;

    if (typeof (input) !== 'string') input = input.toString();
    if (input.length === 10) {
        return input.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    } else if (input.length < 10) {
        // return 'was not supplied enough numbers please pass a 10 digit number'
        return input;
    } else if (input.length > 10) {
        // return 'was supplied too many numbers please pass a 10 digit number'
        return input;
    } else {
        // return 'something went wrong'
        return input;
    }
}

export function validatePhoneNumber(input) {
    if (typeof input !== 'string') {
        return 'Phone number is required.';
    }
    // get digits only from input
    input = input.replace(/\D/g, '');
    // should be 10 digits (area code + phone number)
    if(input.length !== 10) {
        return 'Invalid Phone number.  Must be 10 digits (area code + phone number).';
    }
    return true;
}
